import React, { Component } from 'react';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';

class About extends Component {
  render() {
    return (
      <div className='how-to-use default-shadow'>
        <div>
          <div className='cover-image'>
            <h1>Welcome to Missouri HydroViz</h1>
          </div>
          <div className='content'>
            <p>
              HydroViz is a tool available to MRRIC members and participants that allows the user 
              to explore the physical differences between the Fort Peck Test Flow DEIS alternatives 
              in terms of river stages and flows, reservoir elevations, and dam discharges. HydroViz 
              displays USACE's hydrology and hydraulic (H&H) modelling in an accessible way. An 
              appreciation of the modelled differences between the alternatives helps in understanding 
              the initial ecological and socioeconomic analyses.
            </p>
            <p>
              This tool is being shared to facilitate understanding of the alternatives' potential effects in comparison to the existing operation of the system (No Action alternative) and to enable an open, transparent, collaborative discussion among MRRIC members and participants. These alternatives represent a range of actions that are being evaluated as part of the NEPA process but it is understood that the agency has not selected any of the potential alternatives. Additionally, potential alternatives may be revised following coordination of the draft EIS with Tribes, agencies, and stakeholders. These alternatives do not reflect any past, present, or actual operation of the system.
            </p>
            <p>
              The data displayed in HydroViz is the output of USACE’s hydrologic and hydraulic (H&H) modeling tools 
              including Hydrologic Engineering Center (HEC) Reservoir System Simulation (HEC-ResSim) and River Analysis 
              System (HEC-RAS) models. For full references to documentation of these models and their application on the 
              Missouri River system, please refer to Section 2.4 of 
              <a rel="noopener noreferrer" href='https://usace.contentdm.oclc.org/digital/collection/p16021coll7/id/7886/' target="_blank"> Volume 1 of the Missouri River Recovery Management Plan and Environmental Impact Statement, 2018</a>.
              Updated documentation on minor changes for this DEIS will be forthcoming.
            </p>
            <p>
              The HydroViz tool displays reservoir elevations, dam discharges and river flows and stages resulting 
              from prescriptive modelling rules intended to approximately simulate implementation of alternative 
              operations with water conditions as reflected in the period of record from 1930 to 2012. 
              This has been done to provide a reasonable basis for an analysis of potential effects to 
              a range of listed species and socio-economic objectives.  In real-time operation, actual 
              conditions would be considered when making management action decisions.
            </p>
            <p>
              This information is draft. It is being provided to MRRIC members and participants for their 
              information only. While you are encouraged to discuss the contents of HydroViz with the 
              people you represent, please do not make it publicly available.
            </p>
            <p>
              HydroViz provides access to over 470,000,000 points of data. Compass Resource Management Ltd, 
              the developer of HydroViz, has taken every care to ensure that the underlying USACE data is 
              presented accurately, though be aware it is possible that errors may have been introduced. 
              An error in the display of HydroViz does not necessarily imply an error in the underlying USACE data. 
              Listed ecological and socioeconomic analyses that use USACE data are employing data directly from USACE, 
              not from HydroViz. Do not use HydroViz for anything other than discussion purposes through MRRIC and the MRRP.
            </p>
            <PrimaryButton text="Get Started" onClick={() => this.props.history.push('/charts')}/>
          </div>
        </div>
      </div>
    );
  }
}

export default About;


// WEBPACK FOOTER //
// ./src/containers/About.js